module.exports = __webpack_public_path__ + "img/logo.3733079a.png";